import type { VoiceCallStatus } from '../hooks/useAdminData';

export type VoiceCallBadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

// Source of truth for the 16 VoiceCallStatus values is
// backend-nest/prisma/schema.prisma (VoiceCallStatus enum). Every value MUST
// have an explicit entry here — no `?? 'default'` fallback allowed to mask a
// missing status. Shared by VoiceCalls.tsx and VoiceCallDetail.tsx.
export const VOICE_CALL_STATUS_VARIANT: Record<VoiceCallStatus, VoiceCallBadgeVariant> = {
  scheduled: 'default',
  context_loaded: 'default',
  dialing: 'info',
  detecting: 'info',
  disclosure: 'info',
  discovery: 'info',
  handling: 'info',
  cta: 'info',
  closing: 'info',
  post_processing: 'info',
  completed: 'success',
  no_answer: 'warning',
  voicemail: 'warning',
  hung_up_by_lead: 'warning',
  technical_failure: 'danger',
  cancelled: 'default',
};
